import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Form,
  Button,
  Table,
  Card,
  InputGroup,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
// import "./componentCss/dashboard.css";
import "../css/dashboard.css";
import { FaRegEye } from "react-icons/fa";

import Appsidebar from "../../Appsidebar";
// import Dashboardheader from "./dashboardheader";
// import Sidebar from "./sidebar";
import Header from "../../Header";
import { AiFillInfoCircle } from "react-icons/ai";

// import "./componentCss/sidebar.css";
import "../css/appsidebar.css";
// import "../css/mobileappsidebar.css";
import "../css/mobileappsidebar.css";
import { FiChevronDown } from "react-icons/fi";
import { IoChevronDown } from "react-icons/io5";
import { IoMdTime } from "react-icons/io";
import { PiArrowUpFill } from "react-icons/pi";
import { RiArrowDownFill } from "react-icons/ri";
import { createChart, PriceScaleMode, ColorType } from "lightweight-charts";
// import  Tooltip  from 'react-tooltip'
// import Dashboardfooter from "./dashboardfooter";
import Dashboardfooter from "../../Pages/Dashboardfooter";
import Mobileappsidebar from "../../Mobileappsidebar";
// import { ChartComponent } from "../ChartComponent";
import { FaPencilAlt } from "react-icons/fa";
import * as Yup from "yup";

import {
  getInfiChartData,
  getInfiPoolBalancetData,
  updateUserProfile,
} from "../../../services/apiServices";
// import "./componentCss/dashboardfooter.css";
import {
  FEE_SYMBOL,
  INFI_CONTRACT,
  INFI_DECIMAL,
  LIQUIDITY_CONTRACT,
  TOKEN_A,
  TOKEN_B,
  USDT_CONTRACT,
  USDT_DECIMAL,
} from "../../Web3/web3Config";
import { BloackchainGetTokenBalance } from "../../Web3/SwapConnector";
import { ERROR, Success, Warning } from "../../../utils/errors";
import {
  initializeUseSelector,
  useSelector,
} from "react-redux/es/hooks/useSelector";
import Web3ModalProvider from "../../Pages/Presale/Connectwallet/Web3ModalProvider";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from 'react-bootstrap/Tooltip';
import Tooltip from "react-bootstrap/Tooltip";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
// import Button from 'react-bootstrap/Button';
import * as ACTIONTYPES from "../../../redux/actionTypes";
import { useDispatch } from "react-redux";
import config from "../../../config";

// import Header from '../../Header';

const Profile = (props) => {
  const navigate = useNavigate();
  const [poolBalanceData, setPoolBalanceData] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [initialData, setinitialData] = useState([]);
  const [tokenA, setTokenA] = useState(TOKEN_A);
  const [infibal, setinfibal] = useState(0);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const [WalletAddress, setWalletAddress] = useState("");
  const _useWeb3ModalProvider = Web3ModalProvider();
  const [image_preview, setimage_preview] = useState("");
  const [image_file, setimage_file] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(loginDetails).length==0){
      navigate(`${config.baseurl}login`);
    }
  }, [loginDetails])
  

  const profilePicChange = async (e) => {
    e.preventDefault();
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];
    setimage_file(image_as_files);
    setimage_preview(image_as_base64);
  };
  useEffect(() => {
    console.log(loginDetails, "loginDetails");
  }, [walletConnnected]);

  useEffect(() => {}, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Wallet connection required to check INFI token balance
    </Tooltip>
  );

  const submitForm = async (values) => {
    const formData = new FormData();
    formData.append("file", image_file);
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      emailAddress: values.userName,
    };

    console.log(formData, values, image_file, loginDetails, "payload");

    try {
      let res = await updateUserProfile(formData, loginDetails.accessToken);
      setShowLoading(false);
      console.log(res);
      if (res.data.status) {
        // id: objUser.id,
        // firstName: objUser.firstName,
        // lastName: objUser.lastName,
        // email: objUser.emailAddress,
        // walletAddress: objUser.walletAddress,
        // profilePic: objUser.profilePic,
        let data = {
          id: loginDetails.id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: loginDetails.email,
          walletAddress: loginDetails.walletAddress,
          profilePic: res.data.data,
          accessToken: loginDetails.accessToken
        };
        dispatch({
          type: ACTIONTYPES.USERLOGIN,
          payload: data,
        });
        Success(res.data.message
            );
      } else {
        Warning(res.data.message);
      }
    } catch (error) {
      console.log(error);
      setShowLoading(false);
      ERROR("Something went wrong, Please try again.");
    }
  };

  return (
    <>
      {/* <Dashboardheader /> */}
      <div className="dashboard">
      <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setConnectWalletNow}
      />

      {/* <Dashboardheader /> */}

      <div className="wrapper">
        <Appsidebar />
        {/* <Mobileappsidebar/> */}
        <div id="content" className='position-relative'>
          <Container fluid className="pt-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="profile_sec">
                  <Row className="justify-content-center">
                    <Col lg={12} md={12} className="mx-auto">
                      <div className="py-4 px-4">
                        {/* <h4 className="text-primary">
                                                    Profile
                                                </h4> */}

                        <Card className="cardBox ExchangeForm ">
                          <Row className="justify-content-center">
                            <Col lg={5} md={5} xs={12} className="mx-auto">
                              <div className="text-center formheadbox">
                                <h2 className="text-primary fw-bold mb-1">
                                  Edit Profile
                                </h2>
                              </div>
                              <div className="text-center mt-3 mb-5">
                                <div className="profile card-view rounded-20">
                                  <h4 className="text-white mb-0">
                                    Profile image
                                  </h4>
                                  <div className="uploadfileBox">
                                    <div className="upload-btn-wrapper">
                                      <button className="uploadbtn">
                                        {image_preview ? (
                                          <img
                                            // style={{
                                            //   height: "190px",
                                            //   width: "190px",
                                            //   objectFit: "cover",
                                            // }}
                                            alt=""
                                            src={image_preview}
                                            className="d-profile-img-edit img-fluid"
                                          />
                                        ) : !loginDetails?.profilePic ||
                                          loginDetails?.profilePic ==
                                            undefined ||
                                          loginDetails?.profilePic ==
                                            "undefined" ? (
                                          <img
                                            alt=""
                                            style={{
                                              height: "190px",
                                              width: "190px",
                                              objectFit: "cover",
                                            }}
                                            src="assets/icons/profileIcon.png"
                                            className="d-profile-img-edit img-fluid"
                                          />
                                        ) : (
                                          <img
                                            alt=""
                                            style={{
                                              height: "190px",
                                              width: "190px",
                                              objectFit: "cover",
                                            }}
                                            src={`${
                                              config.s3BaseUrl +
                                              loginDetails?.profilePic
                                            }`}
                                            className="d-profile-img-edit img-fluid editIcon"
                                          />
                                        )}
                                      </button>
                                      <input
                                        onChange={profilePicChange}
                                        type="file"
                                        id="upload_profile_img"
                                      />
                                    </div>
                                    <img
                                      src="assets/icons/editIcon.png"
                                      className="editIcon"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="formDiv">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    firstName: loginDetails.firstName,
                                    lastName: loginDetails.lastName,
                                  }}
                                  validationSchema={Yup.object().shape({
                                    firstName: Yup.string()
                                      .nullable()
                                      .required("Please enter first name"),
                                    lastName: Yup.string()
                                      .nullable()
                                      .required("Please enter last name"),
                                  })}
                                  onSubmit={(values) => {
                                    submitForm(values);
                                  }}
                                >
                                  {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    touched,
                                    values,
                                  }) => (
                                    <Form
                                      className="forms px-4"
                                      onSubmit={handleSubmit}
                                    >
                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="First Name"
                                            aria-label="firstName"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.firstName)}
                                            helperText={errors.firstName}
                                            name="firstName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.firstName}
                                            // value={loginDetails.firstName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.firstName &&
                                          touched.firstName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.firstName}
                                            </small>
                                          )}
                                      </div>
                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="Last Name"
                                            aria-label="lastName"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.lastName)}
                                            helperText={errors.lastName}
                                            name="lastName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.lastName}
                                            // value={loginDetails.lastName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.lastName &&
                                          touched.lastName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.lastName}
                                            </small>
                                          )}
                                      </div>

                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="Email ID"
                                            aria-label="Username"
                                            aria-describedby="basic-addon1"
                                      
                                            name="userName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={loginDetails.email}
                                            className="py-2"
                                            disabled
                                          />
                                        </InputGroup>
                                      
                                      </div>

                                      <div className="submit-btn mt-4">
                                        <Button
                                          type="submit"
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold"
                                        >
                                          Update Profile
                                        </Button>
                                      </div>
                                    </Form>
                                  )}
                                </Formik>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      </div>
    </>
  );
};

export default Profile;
